import { useNavigate, useParams } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import { OrderDeliveriesTable, OrderDocuments } from './components';
import { useOrderQuery } from './order.generated';
import { getOrderId, useParameters } from '@web/utils/src';
import arrowTop from '@web/utils/src/assets/icons/functions/arrow-top.svg';
import { useAppSelector } from '@/store/hooks';
import {
  Delivery,
  Document,
  Order,
  OrderLineItem,
  OrderStatus as OrderStatusType,
} from '@/types';

export type POrder = Pick<
  Order,
  | 'id'
  | 'totalNet'
  | 'orderTotalGross'
  | 'outstandingAmount'
  | 'status'
  | 'confirmedAt'
  | 'currency'
  | 'retailerOrderID'
> & {
  documents: POrderDocument[];
  lineItems: Array<
    Pick<
      OrderLineItem,
      | 'name'
      | 'quantity'
      | 'lineTotalNet'
      | 'amount'
      | 'taxRate'
      | 'deliveryID'
      | 'unit'
    >
  >;
  deliveries: Array<
    Pick<Delivery, 'address' | 'id' | 'type' | 'deliveryAddress'>
  >;
};

export type POrderDocument = Pick<Document, 'url' | 'type' | 'id'>;

export function getStatus(t, status: OrderStatusType) {
  switch (status) {
    case OrderStatusType.Pending:
      return t('order.status.pending');
    case OrderStatusType.Confirmed:
      return t('order.status.confirmed');
    case OrderStatusType.Complete:
      return t('order.status.completed');
    case OrderStatusType.Cancelled:
      return t('order.status.cancelled');

    default:
      return status;
  }
}

type Params = {
  retailerId: string;
  orderId: string;
};

const OrderDetailsPage = () => {
  const { orderId } = useParameters<Params>();
  const navigate = useNavigate();
  const { retailerId } = useParams();
  const settings = useAppSelector((state) => state.retailer.retailer?.settings);

  const [{ data }] = useOrderQuery({ variables: { orderId } });
  const order = data?.currentUser?.order;

  const createdByUser = order?.createdByUser?.id === data?.currentUser?.id;

  const showComments =
    settings?.populateCommentsForReordering ||
    (!settings?.populateCommentsForReordering && createdByUser);

  if (!order) {
    return null;
  }

  return (
    <div className="flex flex-col-reverse md:flex-row gap-4-0">
      <div className="w-full m:dw-[75%]">
        <div className="flex items-center py-2-0">
          <div
            className="h-full flex items-center px-1-0 pl-0 cursor-pointer opacity-70 hover:opacity-90"
            onClick={() => navigate(`/documents/${retailerId}/orders`)}
          >
            <ReactSVG src={arrowTop} className="text-white -rotate-90" />
          </div>
          <p className="text-2-0 font-bd">
            Bestellung: {getOrderId(order.retailerOrderID)}
          </p>
        </div>
        <OrderDeliveriesTable order={order} showComments={showComments} />
      </div>
      <OrderDocuments
        documents={order.documents}
        className="py-2-0 text-body1"
      />
    </div>
  );
};

export default OrderDetailsPage;
